// extracted by mini-css-extract-plugin
export var accordion = "styles-module--accordion--hTwye";
export var container = "styles-module--container--L8pQe";
export var legalPage = "styles-module--legalPage--9G0GC";
export var primary = "#06004d";
export var secondary = "#4dafd7";
export var tab = "styles-module--tab--eqcCe";
export var tabs = "styles-module--tabs--SL4mF";